import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import {
    NoteBruger,
    NoteHenvendelsestype,
    NoteOmraade,
    NoteOmraader,
    NoteOpgavestyringStatus,
    NoteRepository
} from "@e-forsyning/common/note";

@Injectable({ providedIn: "root" })
export class InstallationNoteService {
    private omraader$: Observable<NoteOmraade[]>;
    private henvendelsestyper$: Observable<NoteHenvendelsestype[]>;
    private opgavestyringStatusser$: Observable<NoteOpgavestyringStatus[]>;
    private brugere$: Observable<NoteBruger[]>;

    constructor(private readonly repository: NoteRepository) {}

    public hentOmraader(): Observable<NoteOmraade[]> {
        return (this.omraader$ = this.omraader$ || this.repository.hentOmraader());
    }

    public hentHenvendelsestyper(): Observable<NoteHenvendelsestype[]> {
        return (this.henvendelsestyper$ = this.henvendelsestyper$ || this.repository.hentHenvendelsestyper());
    }

    public hentOpgavestyringStatusser(): Observable<NoteOpgavestyringStatus[]> {
        return (this.opgavestyringStatusser$ = this.opgavestyringStatusser$ || this.repository.hentOpgavestyringStatusser());
    }

    public hentBrugere(): Observable<NoteBruger[]> {
        return (this.brugere$ = this.brugere$ || this.repository.hentBrugere());
    }

    public hentDefaultOmraadeId(): number {
        return NoteOmraader.installation;
    }
}
